import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Backdrop } from "@mui/material";
import Typography from '@mui/material/Typography';
import {  toast } from 'react-toastify';
import '../../assets/style/style.css';
import { useMaterialUIController } from "context";
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import productNoImage from "../../assets/images/no-image.png";
import { handleErrors } from "common.js";
import ReturnSummary from "./components/ReturnSummary.js";
import ReturnItem from "./components/ReturnItem.js";

function Details() {
  const [controller, dispatch]                          = useMaterialUIController();
  const { returnRequestContext }                        = controller;  
  const { returnID }                                    = useParams();  
  const navigate                                        = useNavigate();
  const { t }                                           = useTranslation();
  const baseUrl                                         = Config.baseUrl;
  const bearerToken                                     = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading]                       = useState(false);
  const [pageContent, setPageContent]                   = useState({});
  const [returnItem, setReturnItem]                     = useState({});

  useEffect(() => {
    loadReturnDetails();
  }, []);
  
  const handleReturnDetailsAPIResponse = (responseData) => {
      let returnInfo = responseData.data;
      setPageContent(returnInfo);
      const returnItemColumns  =  [
        { label: `${t("Product ID")}`, field: "productId" },
        { label: `${t("Image")}`, field: "image" },
        { label: `${t("Product Name")}`, field: "title" },        
        { label: `${t("Sku")}`,field: "sku" },
        { label: `${t("Qty")}`, field: "quantity" },
        { label: `${t("Unit Price")}`, field: "price" },        
        { label: `${t("Total Price")}`, field: "totalprice" }
      ];

      let returnRowsList = [];
      let productImage   = returnInfo.productImage ? returnInfo.productImage : productNoImage;
      let totalPrice     = returnInfo.quantity * returnInfo.price;
      let returnRows     = {
                              "productId"    : "#"+returnInfo.vendorProductId,
                              "image"        : <Box className="productImageBox"><img className="productImage" src={productImage} alt={returnInfo.productTitle}  /></Box>,
                              "title"        : <Box className="productTitleBox" title={returnInfo.productTitle}>{returnInfo.productTitle}</Box>,
                              "sku"          : returnInfo.sku ? returnInfo.sku : '-',
                              "quantity"     : returnInfo.quantity,
                              "price"        : `₹${returnInfo.price.toFixed(2)}`,
                              "totalprice"   : `₹${totalPrice.toFixed(2)}`,
                           };

          returnRowsList.push(returnRows);
      setReturnItem({ returnItemColumns, returnRowsList });
  };

  const loadReturnDetails = () => {
    setIsLoading(true);
    axios({      
          url     : baseUrl+"/return/view/"+returnID,
          method  : "GET",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {                    
            setIsLoading(false);
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
                    const redirectTimeout = setTimeout(() => {          
                      clearTimeout(redirectTimeout);          
                      navigate( "/returnRequests/list" );
                    }, 3000);
                }
                else if(responseDataStatusCode === 1 && responseData && responseData.data)
                handleReturnDetailsAPIResponse(responseData);
            }
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }            
        }).catch(function (error) {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
  }
  
  return (
    <DashboardLayout>
        <DashboardNavbar pageTitle={t('Order Return')+' #'+pageContent.orderNumber}/>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      {Object.keys(pageContent).length > 0 ?      
        <MDBox my={3}>
          <Grid container spacing={2} my={1}>
              <Grid item xs={12}>
                <Card mb={2} variant="outlined">
                  <CardContent>
                    <Grid container spacing={0} mt={1}>
                      <Grid item sm={6} xs={12} my={2}>
                        <Typography variant="h6" color="text.secondary">
                          {t('Order return details')}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} component="div">
                          {t('Here are details about order return')}
                        </Typography>
                      </Grid>                  
                    </Grid>
                    <ReturnSummary 
                      returnID    = {returnID} 
                      pageContent = {pageContent} 
                      setIsLoading = {setIsLoading}
                    />  
                  </CardContent>
                </Card>
              </Grid>
              
              {Object.keys(returnItem).length > 0 ?
                <ReturnItem 
                    returnID   = {returnID} 
                    returnItem = {returnItem} 
                /> 
              : null}              
           
          </Grid>
        </MDBox>
          : <></>}        
      </DashboardLayout>
  );
}
export default Details;
